import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
export type StyleProps = {
  width: number | string;
  height: number | string;
  isDefaultImage: boolean;
};
export const useStyles = makeStyles<Theme, StyleProps>(() =>
  createStyles({
    root: (props) => ({
      width: props.width,
      height: props.height,
      background: props.isDefaultImage
        ? 'linear-gradient(128.37deg, #3cd4dd 7.97%, #017ab2 85.8%)'
        : 'transparent',
    }),
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  })
);
